import React from 'react';

export const PBB_CATEGORIES = [
  'Automotive & Transportation',
  'Beauty & Personal Care',
  'Children & Youth',
  'Education & Development',
  'Entertainment, Art & Music',
  'Fashion & Style',
  'Financial Services',
  'Fitness & Recreation',
  'Food & Dining',
  'Health & Wellness',
  'Home & Property Services',
  'Legal & Business Services',
  'Media',
  'Outdoors, Sports & Hobbies',
  'Pets & Animals',
  'Retail & Shopping',
  'Technology',
  'Travel & Tourism',
];

/** Horizontal scrollable category chip bar.
 *  - `counts`: optional { [category]: number } to show counts per chip.
 *  - `value` / `onChange`: controlled state ("All" or a category name). */
export default function CategoryChips({ value = 'All', onChange, counts = null, categories = PBB_CATEGORIES, testId = 'category-chips' }) {
  return (
    <div data-testid={testId} className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1">
      {['All', ...categories].map((c) => {
        const count = counts ? counts[c] : null;
        const active = value === c;
        return (
          <button
            key={c}
            type="button"
            data-testid={`${testId}-${c.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}`}
            onClick={() => onChange?.(c)}
            className={`whitespace-nowrap px-3 py-1.5 rounded-full text-xs border transition-colors ${active ? 'bg-green-600 border-green-500 text-white' : 'bg-[#0d1f14] border-[#153b23] text-gray-300 hover:border-green-500/50 hover:text-green-300'}`}
          >
            {c}{count != null && count > 0 ? <span className={`ml-1.5 text-[10px] ${active ? 'text-green-100' : 'text-gray-500'}`}>{count}</span> : null}
          </button>
        );
      })}
    </div>
  );
}
